import { PageHeader } from "../views/molecules/Molecules"
import React from "react"
import L10n from "../../lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const TalkToCarrotChatHeader = () => <PageHeader icon="icn-talk-to-carrot" title={l`Talk to Carrot`} />

export { TalkToCarrotChatHeader }
